import { render, staticRenderFns } from "./PageError.vue?vue&type=template&id=31f6d596&"
import script from "./PageError.vue?vue&type=script&lang=js&"
export * from "./PageError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports